const SPOTIFY_PIXEL_KEY = "b603a748497646908a9bfc2099cd9a1d";
const PRODUCTION_HOST = "thebatcage.ca";

declare global {
  interface Window {
    spdt?: ((...args: unknown[]) => void) & { q?: IArguments[] };
  }
}

/** Loads the Spotify Ads pixel only on the live production domain. */
export function loadSpotifyAds(): void {
  if (typeof window === "undefined") return;
  if (window.location.hostname !== PRODUCTION_HOST) return;
  if (document.getElementById("spdt-capture")) return;

  window.spdt =
    window.spdt ||
    function spdt() {
      // Match Spotify's snippet: push `arguments`, not a rest-args array.
      // eslint-disable-next-line prefer-rest-params
      (window.spdt!.q = window.spdt!.q || []).push(arguments);
    };

  const script = document.createElement("script");
  script.id = "spdt-capture";
  script.async = true;
  script.src = "https://pixel.byspotify.com/ping.min.js";
  const first = document.getElementsByTagName("script")[0];
  first?.parentNode?.insertBefore(script, first);

  window.spdt("conf", { key: SPOTIFY_PIXEL_KEY });
}

export function trackSpotifyPurchase(options?: {
  value?: number;
  currency?: string;
  orderId?: string;
}): void {
  if (typeof window === "undefined") return;
  if (!window.spdt) return;

  const orderId = options?.orderId?.trim();
  const dedupeKey = `spotify-purchase:${orderId || window.location.pathname}`;
  try {
    if (sessionStorage.getItem(dedupeKey)) return;
    sessionStorage.setItem(dedupeKey, "1");
  } catch {
    // Private mode / blocked storage should still send the event.
  }

  const payload: Record<string, unknown> = {
    currency: options?.currency ?? "CAD",
  };
  if (typeof options?.value === "number" && Number.isFinite(options.value)) {
    payload.value = options.value;
  }
  if (orderId) {
    payload.order_id = orderId;
  }

  window.spdt("purchase", payload);
}
